import { jsx as o } from "react/jsx-runtime";
import { CommentContentHeader as x } from "./components/CommentContentHeader/index.js";
import { CommentContentBody as B } from "./components/CommentContentBody/index.js";
import { CommentContainer as P } from "./style.js";
import { BaseCommentContent as j } from "../BaseCommentContent/index.js";
function k({
  timestamp: t,
  author: n,
  authorImage: e,
  content: m,
  children: r,
  clickoutFunction: C,
  moreOptions: c,
  isEdited: i,
  isDeleted: p,
  isNewComment: s,
  parentComment: a,
  isAuthorVerified: f,
  goToProfile: d,
  profileURL: h
}) {
  const l = {
    author: n,
    authorImage: e,
    moreOptions: c,
    isEdited: i,
    isNewComment: s,
    goToProfile: d,
    timestamp: t,
    isAuthorVerified: f,
    profileURL: h
  }, u = {
    clickoutFunction: C,
    parentComment: a,
    isDeleted: p,
    content: m,
    children: r
  };
  return /* @__PURE__ */ o(P, { children: /* @__PURE__ */ o(
    j,
    {
      className: "comment-content",
      header: /* @__PURE__ */ o(x, { ...l }),
      content: /* @__PURE__ */ o(B, { ...u })
    }
  ) });
}
export {
  k as CommentContent
};
